import { Minus, Plus } from "lucide-react";

export const Counter = ({ label, value, onChange, testid, disabled }) => (
  <div className="flex items-center justify-between rounded-2xl bg-slate-50 border border-slate-200 px-4 py-3">
    <span className="font-semibold text-slate-700">{label}</span>
    <div className="flex items-center gap-4">
      <button data-testid={`${testid}-minus`} disabled={disabled || value <= 0} onClick={() => onChange(value - 1)}
        className="w-11 h-11 rounded-full bg-white border border-slate-200 flex items-center justify-center active:scale-90 transition-transform disabled:opacity-30">
        <Minus className="w-5 h-5" />
      </button>
      <span data-testid={`${testid}-value`} className="num text-3xl font-bold w-8 text-center">{value}</span>
      <button data-testid={`${testid}-plus`} disabled={disabled} onClick={() => onChange(value + 1)}
        className="w-11 h-11 rounded-full bg-cyan-400 text-zinc-950 flex items-center justify-center active:scale-90 transition-transform disabled:opacity-30">
        <Plus className="w-5 h-5" />
      </button>
    </div>
  </div>
);
